<template>
  <div>
    <Dialog
      width="678px"
      :height="createRenderType == 'mobile' ? 'calc(100vh - 50px)' : '618px'"
      titleAlign="left"
      :title="$$t('create.style')"
      :subTitle="$$t('create.add_style')"
      :visible="renderData.visible"
      @close="onClose"
      mobileRenderType="drawerDialog"
    >
      <div
        class="height-all add-music-reference flex-column"
        :class="{
          'add-music-reference-mobile': createRenderType == 'mobile',
        }"
      >
        <div
          class="add-music-reference-edit"
          :class="{
            'add-music-reference-edit-disable': !userDataStore.isLogin,
          }"
        >
          <!-- <AddFileOrLink @saveSuccess="onSaveSuccess"></AddFileOrLink> -->
          <div class="add-music-reference-edit-item flex1 width-0">
            <AddMusicReferFile
              @showSubscribeDialog="showSubscribeDialog"
              @saveSuccess="onSaveSuccess"
            ></AddMusicReferFile>
          </div>

          <div
            class="add-music-reference-edit-item flex1 width-0"
            v-if="ModuleOpenStateControl.speControl.linkCrawling"
          >
            <AddMusicReferLink
              @showSubscribeDialog="showSubscribeDialog"
              @saveSuccess="onSaveSuccess"
            ></AddMusicReferLink>
          </div>
        </div>
        <div class="add-music-reference-tab-box">
          <el-tabs v-model="renderData.activeTab" @tab-click="onTabClick">
            <el-tab-pane :label="$$t('create.library')" name="library">
            </el-tab-pane>
            <el-tab-pane
              :disabled="!userDataStore.isLogin"
              :label="$$t('create.used')"
              name="used"
            >
            </el-tab-pane>
            <el-tab-pane
              :disabled="!userDataStore.isLogin"
              :label="$$t('create.mine')"
              name="mine"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div
          class="add-music-reference-tab-content flex1 height-0"
          ref="referListParentBox"
        >
          <referMusicListAll
            v-show="renderData.activeTab == 'library'"
            :isCurShow="renderData.activeTab == 'library'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
          ></referMusicListAll>
          <ReferMusicListUsed
            v-if="userDataStore.isLogin"
            :isCurShow="renderData.activeTab == 'used'"
            v-show="renderData.activeTab == 'used'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
          ></ReferMusicListUsed>
          <referMusicListUpload
            v-if="userDataStore.isLogin"
            v-show="renderData.activeTab == 'mine'"
            :isCurShow="renderData.activeTab == 'mine'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
            @delete="doDelete"
            @editSongTitle="doEditSongTitle"
          ></referMusicListUpload>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
} from "@/config/config.js";

import { useRouter, useRoute } from "vue-router";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import ReferenceItem from "./referenceItem.vue";

import AddFileOrLink from "./addFileOrLink.vue";
import AddMusicReferFile from "./addFile.vue";
import AddMusicReferLink from "./addLink.vue";
import ReferMusicListAll from "./referMusicListAll.vue";
import ReferMusicListUsed from "./referMusicListUsed.vue";
import referMusicListUpload from "./referMusicListUpload.vue";
import message from "@/components/functionCallComponent/message.jsx";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";
import userReferMusicStore from "@/store/create/referMusicStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const referMusicStore = userReferMusicStore();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const tabCodeMap = {
  1: "library",
  2: "used",
  3: "mine",
};
const referListParentBox = ref(null);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["update:visible", "apply", "showSubscribeDialog"]);
const renderData = reactive({
  visible: props.visible,
  clipSourceData: null,
  activeTab: userDataStore.isLogin
    ? tabCodeMap[referMusicStore.curUseMusicTabCode ?? 1]
    : tabCodeMap[1],
  moreDialogVisible: false,
  reportDialogVisible: false,
  reportSmId: null,
  reportItem: null,
});

const onClose = () => {
  renderData.visible = false;
};

const showSubscribeDialog = (...args) => {
  emits("showSubscribeDialog", ...args);
};

const doApply = (item, tabCode, isback = true) => {
  const draftDataStore = useDraftDataStore();
  referMusicStore.setCurUseMusic(item, tabCode);
  emits("apply");
  onClose();
  // let saveData = {
  //   feed_id: draftDataStore.feed_id,
  //   control_type: 1,
  //   control_resource_id: item.id,
  // };
  // const closeMsg = message.loading({ content: "Saving ..." });
  // apiReferMusic
  //   .saveReferenceMusic(saveData)
  //   .then((res) => {
  //     closeMsg.clear();
  //     if (res.code == 200) {
  //       referMusicStore.setCurUseMusic(item);
  //       onClose();
  //     } else {
  //       if (res.code == "9223") {
  //         message.error({
  //           position: 'top',
  //           content: "The reference song has been deleted and cannot be used",
  //         });
  //       } else if (res.code == "9225") {
  //         message.error({
  //           position: 'top',
  //           content:
  //             "This reference music has been removed, please select again",
  //         });
  //       } else {
  //         message.error({
  //           position: 'top', content: res.msg ?? "save failed" });
  //       }
  //       return;
  //     }
  //   })
  //   .catch((err) => {
  //     closeMsg.clear();
  //   });
};

const doCancel = (item) => {
  referMusicStore.setCurUseMusic(null);
};

const doMore = (item) => {
  renderData.reportItem = item;
  renderData.reportSmId = item.id;
  if (renderData.activeTab == "mine") {
    renderData.moreDialogVisible = true;
  } else {
    renderData.reportDialogVisible = true;
  }
};

const doDelete = (item, tabCode) => {
  referMusicStore.deleteReferItem(item, tabCode);
};

const doEditSongTitle = (item, tabCode) => {
  referMusicStore.doEditSongTitle(item, tabCode);
};

const onSaveSuccess = (ref, isUse = false) => {
  renderData.activeTab = "mine";
  referMusicStore.insertUploadData(ref);
  if (isUse) {
    referMusicStore.setCurUseMusic(ref);
    emits("apply");
    onClose();
  }
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);
const onTabClick = () => {};
onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      [
        ...referListParentBox.value?.querySelectorAll(`.audio-item-refer-box`),
      ].some((item) => {
        if (
          item?.getAttribute("data-refer-id") ==
          referMusicStore.curUseReferMusic?.id
        ) {
          item?.scrollIntoView?.({ behavior: "smooth" });
          return true;
        }
        return false;
      });
    }, 100);
  });
});
</script>
<style lang="scss">
.add-music-reference {
  .add-music-reference-edit {
    padding: 10px 40px 20px 40px;
    display: flex;
    align-items: center;
    position: relative;
    .add-music-reference-edit-item {
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }
  .add-music-reference-tab-box {
    margin-bottom: 16px;
    .el-tabs {
      height: 30px;
    }
    .el-tabs__header {
      margin: 0 40px;
      height: 30px;
    }
    .el-tabs__nav-wrap:after {
      display: none;
    }
    .el-tabs__item {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      height: 28px;
      color: rgba(255, 255, 255, 0.5);
      padding: 0 14px;
      &.is-active {
        color: #fff;
      }
    }
    .el-tabs__active-bar {
      height: 2px;
      background: #ffffff;
    }
    .el-tabs__content {
      height: calc(100% - 30px);
    }
  }
  &.add-music-reference-mobile {
    overflow-x: hidden;
    .add-music-reference-edit {
      padding: 10px 16px 20px 16px;
    }
    .add-music-reference-tab-box {
      height: 40px;
      margin: 0 -24px 8px -24px;
      .el-tabs__item {
        font-size: 16px;
      }
    }
    .add-music-reference-tab-content {
      margin: 0 -24px;
    }
  }
}
</style>
